import { ThumbnailPayload, ThumbnailsResponse, QuickViewPayload, QuickViewResponse, ResponseType } from './shared/model/docavea-viewer-interface';
import { sendResponse } from './send-response';
import { delay } from './main';

export async function makeDocThumbnail(payload: ThumbnailPayload, pdfDocument: any) {
    let result = await makeThumbnail(pdfDocument, payload);
    // in rare cases we get a thumbnail that only contains the gray background. When that happens we retry 
    // eslint-disable-next-line max-len
    if (result.thumbnailURL === 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gIoSUNDX1BST0ZJTEUAAQEAAAIYAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAAHRyWFlaAAABZAAAABRnWFlaAAABeAAAABRiWFlaAAABjAAAABRyVFJDAAABoAAAAChnVFJDAAABoAAAAChiVFJDAAABoAAAACh3dHB0AAAByAAAABRjcHJ0AAAB3AAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAFgAAAAcAHMAUgBHAEIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAABvogAAOPUAAAOQWFlaIAAAAAAAAGKZAAC3hQAAGNpYWVogAAAAAAAAJKAAAA+EAAC2z3BhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABYWVogAAAAAAAA9tYAAQAAAADTLW1sdWMAAAAAAAAAAQAAAAxlblVTAAAAIAAAABwARwBvAG8AZwBsAGUAIABJAG4AYwAuACAAMgAwADEANv/bAEMACAYGBwYFCAcHBwkJCAoMFA0MCwsMGRITDxQdGh8eHRocHCAkLicgIiwjHBwoNyksMDE0NDQfJzk9ODI8LjM0Mv/bAEMBCQkJDAsMGA0NGDIhHCEyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMv/AABEIAlgBkAMBIgACEQEDEQH/xAAVAAEBAAAAAAAAAAAAAAAAAAAABf/EABQQAQAAAAAAAAAAAAAAAAAAAAD/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AigAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//Z') {
        console.warn('thumbnailURL without information generated, retrying');
        await delay(250);
        result = await makeThumbnail(pdfDocument, payload);
    }
    const makeDocResponse: ThumbnailsResponse = {
        numberOfPages: pdfDocument.numPages,
        thumbnailURL: result.thumbnailURL,
        scale: result.scale,
        orientation: payload.orientation,
        pageNumber: payload.pageNumber,
    };
    sendResponse(ResponseType.DOC_THUMBNAIL_MADE, makeDocResponse);
}

export async function makeLoadThumbnail(payload: ThumbnailPayload, pdfDocument: any) {
    const { thumbnailURL, scale } = await makeThumbnail(pdfDocument, payload);
    const makeDocResponse: ThumbnailsResponse = {
        numberOfPages: pdfDocument.numPages,
        thumbnailURL,
        scale,
        orientation: payload.orientation,
        pageNumber: payload.pageNumber,
    };
    sendResponse(ResponseType.LOAD_AND_THUMB_MADE, makeDocResponse);
}

export async function makeQuickView(payload: QuickViewPayload, pdfDocument: any) {
    const quickViewURL = await generateQuickView(pdfDocument, payload);
    const quickViewResponse: QuickViewResponse = {
        markupKey: payload.markupKey,
        numberOfPages: pdfDocument.numPages,
        quickViewURL,
        orientation: payload.orientation,
    };
    sendResponse(ResponseType.QUICKVIEW_MADE, quickViewResponse);
}

async function makeThumbnail(pdfDocument: any, payload: ThumbnailPayload) {
    const canvas = document.createElement('canvas');

    const pageNumber = payload.pageNumber;
    // Get size of current PDF page
    const page = await pdfDocument.getPage(pageNumber);
    // calculate rotation by adding the internal PDF rotate to the orientation send from Docavea
    const rotation = payload.orientation + page._pageInfo.rotate;
    
    // Set canvas size at scale 1 and using the correct rotation
    let scale = 1;
    const viewport = page.getViewport({ scale, rotation });
    canvas.width = payload.width;
    canvas.height = payload.height;

    // Calculate the scale
    scale = Math.min(canvas.width / viewport.width, canvas.height / viewport.height);

    const context = canvas.getContext('2d');
    if (context) {
        context.fillStyle = 'rgb(102,102,102)';
        context.fillRect(0, 0, canvas.width, canvas.height);
    } else {
        console.error(`canvas.getContext('2d') failed`);
    }

    // intent 'print': render without requestAnimationFrame scheduling — the
    // display intent hangs forever in iframes where rAF does not fire (e.g.
    // hidden/offscreen thumbnail processors), and a one-shot raster has no
    // use for animation-frame batching anyway
    await page.render({
        canvasContext: context,
        viewport: page.getViewport({
            scale,
            rotation,
        }),
        intent: 'print',
    }).promise;
    const thumbnailURL = canvas.toDataURL(payload.mimeType, payload.jpegQuality);
    return ({ thumbnailURL, scale });
}

async function generateQuickView(pdfDocument: any, payload: QuickViewPayload) {
    const CSS_UNITS: number = 96.0 / 72.0;
    const pageNumber = payload.pageNumber;
    
    const canvas = document.createElement('canvas');
    canvas.width = payload.scale * payload.width / CSS_UNITS;
    canvas.height = payload.scale * payload.height / CSS_UNITS;
    const canvasContext = canvas.getContext('2d');

    const page = await pdfDocument.getPage(pageNumber);
    await page.render({
        canvasContext,
        viewport: page.getViewport({
            offsetX: payload.scale * payload.offsetX / CSS_UNITS,
            offsetY: payload.scale * payload.offsetY / CSS_UNITS,
            scale: payload.scale,
            rotation: payload.orientation + page._pageInfo.rotate,
        }),
    }).promise;

    return canvas.toDataURL(payload.mimeType, payload.jpegQuality);
}

// let quickViewBorderDiv: HTMLDivElement;
// function borderQuickView(payload: QuickViewPayload, scale) {
//     const pageBorderWidth = 3;
//     if (quickViewBorderDiv !== undefined) {
//         quickViewBorderDiv.remove();
//     }
//     const container = document.getElementById('viewerContainer');
//     quickViewBorderDiv = document.createElement('div');
//     if (quickViewBorderDiv && container) {
//         quickViewBorderDiv.style.width = `${payload.width * scale}px`;
//         quickViewBorderDiv.style.height = `${payload.height * scale}px`;
//         quickViewBorderDiv.style.top = `${container.scrollTop - payload.offsetY * scale}px`;
//         quickViewBorderDiv.style.left = `${container.scrollLeft - payload.offsetX * scale}px`;
//         // quickViewBorderDiv.style.width = `100px`;
//         // quickViewBorderDiv.style.height = `100px`;
//         // quickViewBorderDiv.style.top = `100px`;
//         // quickViewBorderDiv.style.left = `100px`;
//         quickViewBorderDiv.style.borderColor = 'yellow';
//         quickViewBorderDiv.style.position = 'absolute';
//         quickViewBorderDiv.style.borderStyle = 'solid';
//         quickViewBorderDiv.style.borderWidth = `${pageBorderWidth}px`;
//         quickViewBorderDiv.style.margin = '0px';
//         // quickViewBorderDiv.style.margin = `${pageBorderWidth}px`;
//         quickViewBorderDiv.style.pointerEvents = 'none';
//         container.appendChild(quickViewBorderDiv);
//     } else {
//         console.error(`getElementById('viewerContainer') or createElement('div') failed`);
//     }
// }
